import React, { useEffect, useState } from "react";
import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import axios from '../../axios/axiosconf';
import Loading from "../general/Loading";
import Unauthorized from "../general/Unauthorized";
import { Link } from "react-router-dom";

function ReporteFacturacion() {
    const [loggedIn, setLoggedIn] = useState(false);
    const [hasPermission, setHasPermission] = useState(false);
    const [client, setClient] = useState([]);
    const [loading, setLoading] = useState(false);
    const [facturas, setFacturas] = useState([]);
    const [usuarios, setUsuarios] = useState([]);
    const [pacientes, setPacientes] = useState([]);

    // Filtros
    const [fechaDesde, setFechaDesde] = useState('');
    const [fechaHasta, setFechaHasta] = useState('');
    const [filtroEstado, setFiltroEstado] = useState('');
    const [todasLasFacturas, setTodasLasFacturas] = useState(false);

    useEffect(() => {
        console.log('ReporteFacturacion: useEffect iniciado');
        
        if (!localStorage.getItem('userdata')) {
            setHasPermission(false);
            setLoggedIn(true);
            return;
        }

        let userdata = JSON.parse(localStorage.getItem('userdata'));
        console.log('ReporteFacturacion: userdata cargado', userdata);

        // 🔒 VALIDACIÓN DE PERMISOS - Patrón híbrido (nuevo + legacy)
        let tienePermiso = false;
        if (userdata.permissions && Array.isArray(userdata.permissions)) {
            tienePermiso = userdata.permissions.some(permission => permission.slug === 'ver_listado_facturas');
        } else if (userdata.up && userdata.up.includes('ver_listado_facturas')) {
            tienePermiso = true;
        }

        if (!tienePermiso) {
            console.log('ReporteFacturacion: Sin permisos');
            setHasPermission(false);
            setLoggedIn(true);
            return;
        }

        console.log('ReporteFacturacion: Con permisos, cargando datos');
        setHasPermission(true);

        // ✅ Sin config manual - el interceptor agrega el token automáticamente
        axios.get('/get-client?uid=' + userdata.user_id)
            .then(response => {
                console.log('ReporteFacturacion: Cliente cargado', response.data);
                if (response.status === 200) {
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                console.log('ReporteFacturacion: Error cargando cliente', error);
                setLoggedIn(true);
            });

        // Cargar usuarios del cliente
        axios.get('/users-by-client?uid=' + userdata.user_id)
            .then(response => {
                console.log('ReporteFacturacion: Usuarios cargados', response.data);
                if (response.status === 200) {
                    setUsuarios(response.data);
                }
            })
            .catch(error => {
                console.log('Error cargando usuarios (puede ser por permisos):', error.response?.status);
                setUsuarios([]);
            });

        // Cargar pacientes con filtro para solo pacientes (no empresas)
        axios.get('/pacientes', { 
            params: { 
                uid: userdata.user_id,
                solo_pacientes: true // ✅ Filtrar solo pacientes, no empresas
            }
        })
            .then(response => {
                console.log('ReporteFacturacion: Pacientes cargados', response.data);
                if (response.status === 200) {
                    setPacientes(response.data);
                }
            })
            .catch(error => {
                console.log('Error cargando pacientes: ' + error);
            });
    }, []);

    // Ejecutar búsqueda automáticamente cuando cambie el checkbox de "todas las facturas"
    useEffect(() => {
        if (loggedIn && pacientes.length > 0) {
            cargarReporte();
        }
    }, [todasLasFacturas]);

    const cargarReporte = () => {
        console.log('ReporteFacturacion: cargarReporte iniciado');
        console.log('ReporteFacturacion: todasLasFacturas =', todasLasFacturas);
        setLoading(true);
        let userdata = JSON.parse(localStorage.getItem('userdata'));
        
        const params = new URLSearchParams({
            uid: userdata.user_id
        });

        // Solo agregar fechas si NO está marcado "Todas las facturas"
        if (!todasLasFacturas) {
            if (fechaDesde) {
                params.append('fecha_inicio', fechaDesde);
                console.log('ReporteFacturacion: Agregando fecha_inicio =', fechaDesde);
            }
            if (fechaHasta) {
                params.append('fecha_fin', fechaHasta);
                console.log('ReporteFacturacion: Agregando fecha_fin =', fechaHasta);
            }
        } else {
            console.log('ReporteFacturacion: Saltando filtros de fecha porque todasLasFacturas está marcado');
            // Para "todas las facturas", establecer un rango muy amplio que cubra cualquier escenario
            params.append('fecha_inicio', '1990-01-01');
            params.append('fecha_fin', '3000-12-31');
        }
        
        if (filtroEstado !== '') {
            params.append('estado', filtroEstado);
            console.log('ReporteFacturacion: Agregando estado =', filtroEstado);
        }

        console.log('ReporteFacturacion: URL final:', '/facturas?' + params.toString());

        axios.get('/facturas?' + params.toString())
            .then(response => {
                console.log('ReporteFacturacion: Facturas cargadas', response.data);
                console.log('ReporteFacturacion: Cantidad de facturas:', response.data.length);
                setFacturas(response.data);
                setLoading(false);
            })
            .catch(error => {
                console.error('ReporteFacturacion: Error cargando facturas', error);
                console.error('ReporteFacturacion: Status:', error.response?.status);
                console.error('ReporteFacturacion: Data:', error.response?.data);
                setLoading(false);
            });
    };

    const handleLimpiarFiltros = () => {
        setFechaDesde('');
        setFechaHasta('');
        setFiltroEstado('');
        setTodasLasFacturas(false);
        // Recargar sin filtros
        setTimeout(() => {
            cargarReporte();
        }, 100);
    };

    const getNombrePaciente = (pacienteId) => {
        const paciente = pacientes.find(p => p.id === pacienteId);
        if (paciente) {
            return `${paciente.primer_nombre || ''} ${paciente.segundo_nombre || ''} ${paciente.primer_apellido || ''} ${paciente.segundo_apellido || ''}`.trim();
        }
        return 'N/A';
    };

    const getNombreUsuario = (usuarioId) => {
        if (usuarios.length === 0) {
            return `Usuario ${usuarioId}`;
        }
        const usuario = usuarios.find(u => u.id === usuarioId);
        return usuario ? usuario.name : `Usuario ${usuarioId}`;
    };

    const getEstadoTexto = (estado) => {
        switch (estado) {
            case 0: return 'Generada';
            case 1: return 'Cobrada';
            case 2: return 'Por Cobrar';
            case 3: return 'Anulada';
            case 4: return 'Cobrada';
            case 5: return 'Por Cobrar';
            case 6: return 'Error DIAN';
            default: return 'Desconocido';
        }
    };

    const getEstadoColor = (estado) => {
        switch (estado) {
            case 0: return 'badge badge-outline-secondary';
            case 1: return 'badge badge-outline-success';
            case 2: return 'badge badge-outline-warning';
            case 3: return 'badge badge-outline-danger';
            case 4: return 'badge badge-outline-success';
            case 5: return 'badge badge-outline-warning';
            case 6: return 'badge badge-outline-danger';
            default: return 'badge badge-outline-secondary';
        }
    };

    const exportarExcel = () => {
        if (facturas.length === 0) {
            alert('No hay datos para exportar');
            return;
        }

        import('xlsx').then(XLSX => {
            const datosExcel = facturas.map(f => ({
                'Prefijo': f.prefijo || '',
                'N° Factura': f.numero_factura || f.consecutivo || '',
                'Tipo': f.tipo_factura === 'no_electronica' || [4, 5].includes(f.estado) ? 'No Elect.' : 'Elect.',
                'Fecha': new Date(f.fecha_emision).toLocaleDateString(),
                'Paciente': getNombrePaciente(f.paciente_id),
                'Profesional': getNombreUsuario(f.users_id),
                'Total': f.valor_total || 0,
                'Por Cobrar': (f.estado === 2 || f.estado === 5) ? (f.valor_pendiente || f.valor_total) : 0,
                'DIAN': [1, 2, 3].includes(f.estado) ? 'ENVIADO' : [4, 5].includes(f.estado) ? 'NO APLICA' : 'NO ENVIADO',
                'Estado': getEstadoTexto(f.estado)
            }));

            const ws = XLSX.utils.json_to_sheet(datosExcel);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "Facturacion");
            const fecha = new Date().toISOString().split('T')[0];
            XLSX.writeFile(wb, `reporte_facturacion_${fecha}.xlsx`);
        }).catch(() => {
            // Fallback a CSV si XLSX falla
            exportarCSV();
        });
    };

    const exportarCSV = () => {
        if (facturas.length === 0) {
            alert('No hay datos para exportar');
            return;
        }

        const headers = ['Prefijo', 'N° Factura', 'Tipo', 'Fecha', 'Paciente', 'Profesional', 'Total', 'Por Cobrar', 'DIAN', 'Estado'];
        const csvContent = [
            headers.join(','),
            ...facturas.map(f => [
                f.prefijo || '',
                f.numero_factura || f.consecutivo || '',
                f.tipo_factura === 'no_electronica' || [4, 5].includes(f.estado) ? 'No Elect.' : 'Elect.',
                new Date(f.fecha_emision).toLocaleDateString(),
                `"${getNombrePaciente(f.paciente_id)}"`,
                `"${getNombreUsuario(f.users_id)}"`,
                f.valor_total || 0,
                (f.estado === 2 || f.estado === 5) ? (f.valor_pendiente || f.valor_total) : 0,
                [1, 2, 3].includes(f.estado) ? 'ENVIADO' : [4, 5].includes(f.estado) ? 'NO APLICA' : 'NO ENVIADO',
                getEstadoTexto(f.estado)
            ].join(','))
        ].join('\n');

        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', `reporte_facturacion_${new Date().toISOString().split('T')[0]}.csv`);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    if (hasPermission === false) return <Unauthorized />;
    if (!loggedIn) return <Loading />;

    return (
        <div className="hold-transition">
            <Header client={client} />
            <Aside client={client} activelink="reports" />
            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-12">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to="/home">Home</Link></li>
                                    <li className="breadcrumb-item"><Link to="/estadisticas">Reportes</Link></li>
                                    <li className="breadcrumb-item">Reporte de Facturación</li>
                                </ol>
                            </div>
                        </div>
                        <h1 className="m-0">Reporte de Facturación</h1>
                    </div>
                </div>

                <section className="content">
                    <div className="container-fluid">

                        {/* FILTROS */}
                        <div className="card">
                            <div className="card-header">
                                <h3 className="card-title">Filtros de Búsqueda</h3>
                            </div>
                            <div className="card-body">
                                {/* Primera fila - Filtros básicos */}
                                <div className="row">
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label htmlFor="fechaDesde">Fecha Desde</label>
                                            <input 
                                                type="date" 
                                                className="form-control form-control-sm" 
                                                id="fechaDesde"
                                                value={fechaDesde} 
                                                disabled={todasLasFacturas}
                                                onChange={e => {
                                                    setFechaDesde(e.target.value);
                                                    if (e.target.value) {
                                                        setTodasLasFacturas(false);
                                                    }
                                                }} 
                                            />
                                            {todasLasFacturas && (
                                                <small className="text-muted" style={{ fontSize: '0.75rem' }}>Deshabilitado</small>
                                            )}
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label htmlFor="fechaHasta">Fecha Hasta</label>
                                            <input 
                                                type="date" 
                                                className="form-control form-control-sm" 
                                                id="fechaHasta"
                                                value={fechaHasta} 
                                                disabled={todasLasFacturas}
                                                onChange={e => {
                                                    setFechaHasta(e.target.value);
                                                    if (e.target.value) {
                                                        setTodasLasFacturas(false);
                                                    }
                                                }} 
                                            />
                                            {todasLasFacturas && (
                                                <small className="text-muted" style={{ fontSize: '0.75rem' }}>Deshabilitado</small>
                                            )}
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label htmlFor="filtroEstado">Estado</label>
                                            <select className="form-control" id="filtroEstado" value={filtroEstado} onChange={e => setFiltroEstado(e.target.value)}>
                                                <option value="">Todos</option>
                                                <option value="1">Pagada</option>
                                                <option value="0">Generada</option>
                                                <option value="2">Por Cobrar</option>
                                                <option value="3">Anulada</option>
                                                <option value="4">No Electrónica Pagada</option>
                                                <option value="5">No Electrónica Pendiente</option>
                                                <option value="6">Error DIAN</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label htmlFor="todasLasFacturas">Opciones</label>
                                            <div className="form-check" style={{ marginTop: '8px' }}>
                                                <input 
                                                    className="form-check-input" 
                                                    type="checkbox" 
                                                    id="todasLasFacturas"
                                                    checked={todasLasFacturas}
                                                    onChange={(e) => {
                                                        console.log('Checkbox cambiado a:', e.target.checked);
                                                        setTodasLasFacturas(e.target.checked);
                                                        if (e.target.checked) {
                                                            setFechaDesde('');
                                                            setFechaHasta('');
                                                        }
                                                    }}
                                                />
                                                <label className="form-check-label" htmlFor="todasLasFacturas" style={{ fontSize: '0.9rem' }}>
                                                    <strong>Todas las facturas del cliente</strong>
                                                    <br />
                                                    <small className="text-muted">Sin filtro de fechas</small>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-12">
                                        <button
                                            type="button"
                                            className="btn btn-primary mr-2"
                                            onClick={cargarReporte}
                                            disabled={loading}
                                        >
                                            <i className="fas fa-search"></i> Buscar
                                            {loading && <span className="spinner-border spinner-border-sm ml-2"></span>}
                                        </button>
                                        <button
                                            type="button"
                                            className="btn btn-secondary mr-2"
                                            onClick={handleLimpiarFiltros}
                                        >
                                            <i className="fas fa-eraser"></i> Limpiar Filtros
                                        </button>
                                        <button
                                            type="button"
                                            className="btn btn-success mr-2"
                                            onClick={exportarExcel}
                                            disabled={facturas.length === 0}
                                            title="Exportar datos a Excel (o CSV si Excel no está disponible)"
                                        >
                                            <i className="fas fa-file-excel"></i> Excel
                                        </button>
                                        <button
                                            type="button"
                                            className="btn btn-info"
                                            onClick={exportarCSV}
                                            disabled={facturas.length === 0}
                                            title="Exportar datos a CSV"
                                        >
                                            <i className="fas fa-file-csv"></i> CSV
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* TABLA DE RESULTADOS */}
                        <div className="card">
                            <div className="card-header">
                                <h3 className="card-title">
                                    Resultados ({facturas.length} facturas encontradas)
                                </h3>
                            </div>
                            <div className="card-body">
                                {loading ? (
                                    <div className="text-center">
                                        <div className="spinner-border" role="status">
                                            <span className="sr-only">Cargando...</span>
                                        </div>
                                    </div>
                                ) : (
                                    <div className="table-responsive" style={{ overflowX: 'auto' }}>
                                        <table className="table table-bordered table-striped" style={{ minWidth: '1200px', fontSize: '0.85rem' }}>
                                            <thead>
                                                <tr>
                                                    <th style={{ minWidth: '120px', textAlign: 'center', fontSize: '0.8rem' }}>N° Factura</th>
                                                    <th style={{ minWidth: '80px', textAlign: 'center', fontSize: '0.8rem' }}>Tipo</th>
                                                    <th style={{ minWidth: '100px', textAlign: 'center', fontSize: '0.8rem' }}>Fecha</th>
                                                    <th style={{ minWidth: '180px', textAlign: 'center', fontSize: '0.8rem' }}>Paciente</th>
                                                    <th style={{ minWidth: '150px', textAlign: 'center', fontSize: '0.8rem' }}>Profesional</th>
                                                    <th style={{ minWidth: '100px', textAlign: 'center', fontSize: '0.8rem' }}>Total</th>
                                                    <th style={{ minWidth: '100px', textAlign: 'center', fontSize: '0.8rem' }}>Por Cobrar</th>
                                                    <th style={{ minWidth: '80px', textAlign: 'center', fontSize: '0.8rem' }}>DIAN</th>
                                                    <th style={{ minWidth: '100px', textAlign: 'center', fontSize: '0.8rem' }}>Estado</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {facturas.length > 0 ? facturas.map((factura, i) => (
                                                    <tr key={i}>
                                                        <td style={{ fontSize: '0.8rem' }}>
                                                            {(factura.tipo_factura === 'electronica' || [0, 1, 2, 3].includes(factura.estado)) && factura.prefijo ? (
                                                                <strong>{factura.prefijo}-{factura.numero_factura}</strong>
                                                            ) : (
                                                                <strong>{factura.numero_factura}</strong>
                                                            )}
                                                        </td>
                                                        <td className="text-center" style={{ fontSize: '0.8rem' }}>
                                                            <span className="badge badge-outline" style={{
                                                                borderColor: factura.tipo_factura === 'no_electronica' || [4, 5].includes(factura.estado) ? '#ffc107' : '#17a2b8',
                                                                color: factura.tipo_factura === 'no_electronica' || [4, 5].includes(factura.estado) ? '#ffc107' : '#17a2b8',
                                                                borderWidth: '1px',
                                                                borderStyle: 'solid',
                                                                fontSize: '0.7rem'
                                                            }}>
                                                                <i className={`fas ${factura.tipo_factura === 'no_electronica' || [4, 5].includes(factura.estado)
                                                                    ? 'fa-file-alt'
                                                                    : 'fa-bolt'
                                                                    } mr-1`}></i>
                                                                {
                                                                    factura.tipo_factura === 'no_electronica' || [4, 5].includes(factura.estado)
                                                                        ? 'No Elect.'
                                                                        : 'Elect.'
                                                                }
                                                            </span>
                                                        </td>
                                                        <td style={{ fontSize: '0.8rem' }}>{new Date(factura.fecha_emision).toLocaleDateString()}</td>
                                                        <td style={{ fontSize: '0.8rem', wordWrap: 'break-word' }}>
                                                            <span title={getNombrePaciente(factura.paciente_id)}>
                                                                {getNombrePaciente(factura.paciente_id).length > 25
                                                                    ? getNombrePaciente(factura.paciente_id).substring(0, 25) + '...'
                                                                    : getNombrePaciente(factura.paciente_id)
                                                                }
                                                            </span>
                                                        </td>
                                                        <td style={{ fontSize: '0.8rem', wordWrap: 'break-word' }}>{getNombreUsuario(factura.users_id)}</td>
                                                        <td className="text-right" style={{ fontSize: '0.8rem' }}>
                                                            <strong>${Math.round(parseFloat(factura.valor_total)).toLocaleString('es-CO')}</strong>
                                                        </td>
                                                        <td className="text-right" style={{ fontSize: '0.8rem' }}>
                                                            {(factura.estado === 2 || factura.estado === 5) ? (
                                                                <span className="text-danger font-weight-bold">
                                                                    ${Math.round(parseFloat(factura.valor_pendiente || factura.valor_total)).toLocaleString('es-CO')}
                                                                </span>
                                                            ) : (
                                                                <span className="text-success">$0</span>
                                                            )}
                                                        </td>
                                                        <td className="text-center" style={{ fontSize: '0.8rem' }}>
                                                            <span className={`badge ${[1, 2, 3].includes(factura.estado) ? 'badge-outline-success' : [4, 5].includes(factura.estado) ? 'badge-outline-warning' : 'badge-outline-secondary'}`} style={{ fontSize: '0.7rem' }}>
                                                                {[1, 2, 3].includes(factura.estado) ? 'ENVIADO' : [4, 5].includes(factura.estado) ? 'NO APLICA' : 'NO ENVIADO'}
                                                            </span>
                                                        </td>
                                                        <td className="text-center" style={{ fontSize: '0.8rem' }}>
                                                            <span className={`badge ${getEstadoColor(factura.estado)}`} style={{ fontSize: '0.7rem' }}>
                                                                {getEstadoTexto(factura.estado)}
                                                            </span>
                                                        </td>
                                                    </tr>
                                                )) : (
                                                    <tr>
                                                        <td colSpan="9" className="text-center" style={{ fontSize: '0.8rem' }}>
                                                            No se encontraron facturas con los filtros aplicados
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                            </div>
                        </div>

                    </div>
                </section>
            </div>
            <Footer />
        </div>
    );
}

export default ReporteFacturacion;